var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOficina(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.4,378.5c-5.3-3.5-11.3-5.7-17.6-6.5c12.1-9.5,19.5-23.7,20.4-39.1c0-51.1-29.4-61.9-54.1-61.9 s-54.1,10.7-54.1,61.9c0.9,15.3,8.3,29.6,20.4,39.1c-20.5,2.5-35.9,20-35.9,40.6v51.8c0,4.3,3.5,7.7,7.7,7.7H140 c4.3,0,7.7-3.5,7.7-7.7v-51.8C147.7,398.9,140.8,386.1,129.4,378.5z M78.1,400.1l6.4,16l-6.4,6.4l-6.4-6.4L78.1,400.1z M40.5,340.2 c13.2-1.1,37.1-5.1,48.3-19.8l27.6,16.6c-3.1,18.9-26.4,34.5-38.3,34.5C60.8,368.6,46.5,356.7,40.5,340.2z M78.1,286.5 c22,0,34,10.4,37.5,32l-25.8-15.5c-3.7-2.2-8.4-1-10.6,2.7c-0.3,0.5-0.5,1-0.7,1.5c-3.9,11.7-25,16.2-38.7,17.5 C41.9,298.8,54.1,286.5,78.1,286.5z M132.2,456.7H23.9v-44.1c0-14.1,11.4-25.5,25.5-25.5h17.2l-11.2,28.1c-1.1,2.9-0.5,6.2,1.7,8.3 l15.5,15.5c3,3,7.9,3,10.9,0L99,423.5c2.2-2.2,2.9-5.5,1.7-8.3L89.5,387h17.2c14.1,0,25.5,11.4,25.5,25.5V456.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.9,378.5c-5.3-3.5-11.3-5.7-17.6-6.5c12.1-9.5,19.5-23.7,20.4-39.1c0-51.1-29.4-61.9-54.1-61.9 s-54.1,10.7-54.1,61.9c0.9,15.3,8.3,29.6,20.4,39.1c-20.5,2.5-35.9,20-35.9,40.6v51.8c0,4.3,3.5,7.7,7.7,7.7h123.8 c4.3,0,7.7-3.5,7.7-7.7v-51.8C310.1,398.9,303.3,386.1,291.9,378.5z M240.5,400.1l6.4,16l-6.4,6.4l-6.4-6.4L240.5,400.1z  M202.9,340.2c13.2-1.1,37.1-5.1,48.3-19.8l27.6,16.6c-3.1,18.9-26.4,34.5-38.3,34.5C223.3,368.6,208.9,356.7,202.9,340.2z  M240.5,286.5c22,0,34,10.4,37.5,32l-25.8-15.5c-3.7-2.2-8.4-1-10.6,2.7c-0.3,0.5-0.5,1-0.7,1.5c-3.9,11.7-25,16.2-38.7,17.5 C204.3,298.8,216.5,286.5,240.5,286.5z M294.7,456.7H186.4v-44.1c0-14.1,11.4-25.5,25.5-25.5h17.2l-11.2,28.1 c-1.1,2.9-0.5,6.2,1.7,8.3l15.5,15.5c3,3,7.9,3,10.9,0l15.5-15.5c2.2-2.2,2.9-5.5,1.7-8.3L251.9,387h17.2 c14.1,0,25.5,11.4,25.5,25.5V456.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.3,378.5c-5.3-3.5-11.3-5.7-17.6-6.5c12.1-9.5,19.5-23.7,20.4-39.1c0-51.1-29.4-61.9-54.1-61.9 c-24.7,0-54.1,10.7-54.1,61.9c0.9,15.3,8.3,29.6,20.4,39.1c-20.5,2.5-35.9,20-35.9,40.6v51.8c0,4.3,3.5,7.7,7.7,7.7h123.8 c4.3,0,7.7-3.5,7.7-7.7v-51.8C472.6,398.9,465.7,386.1,454.3,378.5z M402.9,400.1l6.4,16l-6.4,6.4l-6.4-6.4L402.9,400.1z  M365.3,340.2c13.2-1.1,37.1-5.1,48.3-19.8l27.6,16.6c-3.1,18.9-26.4,34.5-38.3,34.5C385.7,368.6,371.3,356.7,365.3,340.2z  M402.9,286.5c22,0,34,10.4,37.5,32l-25.8-15.5c-3.7-2.2-8.4-1-10.6,2.7c-0.3,0.5-0.5,1-0.7,1.5c-3.9,11.7-25,16.2-38.7,17.5 C366.8,298.8,379,286.5,402.9,286.5z M457.1,456.7H348.8v-44.1c0-14.1,11.4-25.5,25.5-25.5h17.2l-11.2,28.1 c-1.1,2.9-0.5,6.2,1.7,8.3l15.5,15.5c3,3,7.9,3,10.9,0l15.5-15.5c2.2-2.2,2.9-5.5,1.7-8.3L414.4,387h17.2 c14.1,0,25.5,11.4,25.5,25.5V456.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.4,255.6H372v-15.5h-7.7V139.5c0-4.3-3.5-7.7-7.7-7.7h-69.6v-23.2c0-4.3-3.5-7.7-7.7-7.7h-47 c-11.4-19.8-32.7-31.7-55.5-30.9c-33.9,1.9-60.4,30.2-60,64.2c0,20.2,5.7,40,16.6,57l31.2,49h-9.1V255.6z M310.1,240.1v-23.2h15.5 v23.2H310.1z M348.8,147.3v7.7h-15.5v15.5h15.5v7.7h-15.5v15.5h15.5v46.4h-7.7v-30.9c0-4.3-3.5-7.7-7.7-7.7h-30.9 c-4.3,0-7.7,3.5-7.7,7.7v30.9h-7.7v-46.4h15.5v-15.5h-15.5v-7.7h15.5V155h-15.5v-7.7H348.8z M271.4,116.3v123.8h-54.1v-38.6 l6.6-10.4c10.9-17,16.6-36.8,16.6-57v-2.3c0-5.2-0.7-10.4-2-15.5H271.4z M132.2,134.1c-0.4-25.6,19.4-47.1,45-48.7h1.4 c25.6,0,46.4,20.8,46.4,46.4v2.3c0,17.3-4.9,34.2-14.2,48.7l-32.2,50.6l-32.2-50.6C137.1,168.2,132.2,151.3,132.2,134.1z  M201.8,225.8v14.3h-9.1L201.8,225.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.2,
    y: 124.1,
    className: "st0",
    width: 15.5,
    height: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.1,
    y: 155,
    className: "st0",
    width: 15.5,
    height: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.1,
    y: 178.2,
    className: "st0",
    width: 15.5,
    height: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.2,
    y: 147.3,
    className: "st0",
    width: 15.5,
    height: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.2,
    y: 170.5,
    className: "st0",
    width: 15.5,
    height: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 193.7,
    className: "st0",
    width: 15.5,
    height: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.2,
    y: 193.7,
    className: "st0",
    width: 15.5,
    height: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 216.9,
    className: "st0",
    width: 15.5,
    height: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.2,
    y: 216.9,
    className: "st0",
    width: 15.5,
    height: 15.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.2,185c-0.6-5.2-1.5-10.5-2.5-15.6l-15.2,3.1c1,4.7,1.7,9.6,2.3,14.4L440.2,185z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.8,185.4l15.4,1.8c0.6-4.8,1.3-9.6,2.3-14.4l-15.2-3C42.2,175,41.4,180.2,40.8,185.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M402.3,118.1c2.4,4.2,4.6,8.6,6.7,13l14-6.5c-2.2-4.8-4.6-9.5-7.2-14L402.3,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M386.1,94c3,3.8,5.9,7.7,8.6,11.8l12.8-8.6c-2.9-4.4-6.1-8.6-9.3-12.7L386.1,94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.3,97.4l12.9,8.6c2.7-4,5.6-8,8.6-11.8l-12.1-9.6C79.4,88.7,76.2,93,73.3,97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.3,72.6c3.6,3.3,7.1,6.8,10.3,10.3L388,72.4c-3.5-3.8-7.3-7.6-11.2-11.1L366.3,72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.9,124.8l14,6.5c2-4.4,4.3-8.8,6.6-13l-13.5-7.6C62.5,115.3,60.1,120.1,57.9,124.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47,154.5l14.9,4.2c1.3-4.6,2.8-9.3,4.5-13.9l-14.5-5.4C50,144.4,48.4,149.4,47,154.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.5,72.8L104,61.5c-3.9,3.6-7.6,7.3-11.2,11.2l11.4,10.5C107.5,79.6,111,76.1,114.5,72.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M414.6,144.5c1.7,4.6,3.2,9.2,4.5,13.8l14.9-4.2c-1.4-5-3.1-10.1-4.9-15L414.6,144.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.8,15.6c-5.1,1.4-10.1,3.1-15,4.9l5.4,14.5c4.5-1.7,9.2-3.2,13.8-4.5L185.8,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.7,9.5c-5.2,0.6-10.4,1.4-15.6,2.5l3,15.2c4.8-0.9,9.6-1.7,14.4-2.3L216.7,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.2,8.2C243,8,237.7,8,232.5,8.2l0.6,15.5c4.8-0.2,9.7-0.2,14.6,0L248.2,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.2,26.5c-4.7,2.2-9.5,4.6-14,7.2l7.6,13.5c4.2-2.4,8.6-4.6,13-6.6L156.2,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.9,9.4l-1.8,15.4c4.8,0.5,9.6,1.3,14.4,2.2l3-15.2C274.3,10.8,269.1,10,263.9,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352,41.8l-8.6,12.9c4,2.7,8,5.5,11.8,8.6l9.6-12.2C360.6,47.8,356.3,44.6,352,41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.9,15.5l-4.2,14.9c4.6,1.3,9.3,2.8,13.8,4.5l5.3-14.5C305,18.5,299.9,16.9,294.9,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.4,54.8l-8.6-12.8c-4.4,2.9-8.7,6.1-12.7,9.3l9.6,12.1C129.3,60.4,133.3,57.5,137.4,54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M324.5,26.4l-6.5,14c4.4,2,8.7,4.2,13,6.6l7.5-13.5C334,31,329.2,28.6,324.5,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.6,131.8c0-17.1-13.9-30.9-30.9-30.9s-30.9,13.9-30.9,30.9s13.9,30.9,30.9,30.9S209.6,148.9,209.6,131.8z  M163.2,131.8c0-8.5,6.9-15.5,15.5-15.5s15.5,6.9,15.5,15.5s-6.9,15.5-15.5,15.5S163.2,140.4,163.2,131.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOficina);
export default __webpack_public_path__ + "static/media/oficina.70b05c7f4b99730a5227d6039a99039d.svg";
export { ForwardRef as ReactComponent };